import React from "react";

const PageLoader = () => {
    return (
        <div className="flex h-screen w-full items-center justify-center bg-white dark:bg-[#171717]">
            <div className="flex flex-col items-center gap-6">
                {/* SVG Spinner */}
                <div className="relative h-12 w-12">
                    <svg
                        className="animate-spin"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M12 3C8 3 4.5 5.5 3 9"
                            stroke="#F97316"
                            strokeWidth="4"
                            strokeLinecap="round"
                        />
                    </svg>
                </div>

                {/* Text */}
                <span className="text-3xl font-medium tracking-tight text-orange-500">
                    Just a moment...
                </span>
            </div>
        </div>
    );
};

export default PageLoader;
